import React from "react";
import { CircleButton } from "_c/button";
// import { useHistory } from "react-router-dom";
// import AvatarIcon from "_c/icon/User";
import SaloonIcon from "_c/icon/Building";
import { Link } from "react-router-dom";
import { LinkGenerator } from "@/utils/LinkGenerator";
import Tooltip from "_c/Tooltip";
import { ORDERS_NS as ns } from "@/i18n/ns";
import CarIcon from "_c/icon/Car";
import HomeIcon from "_c/icon/Home";
import MoneyIcon from "_c/icon/Money";
// import EnvelopeIcon from "_c/icon/Envelope";
import { InfoBadge } from "./styled";
import GlobeIcon from "_c/icon/Globe";
// import PinIcon from "_c/icon/Pin";
import { CurrencyFormatter } from "@/i18n/currency";
import type { tAnyTask } from "@/types";
import { TFunction } from "react-i18next";

type tProps = {
  task: tAnyTask;
  openClientProfile: tVoidFn;
  isTaskConsumer: boolean;
  t: TFunction;
};
const TaskBadges = (props: tProps) => {
  // const history = useHistory();
  // const onTaskParticipantClick = () => {
  //   if (props.isTaskConsumer) {
  //     history.push(LinkGenerator.masterProfile(props.task.master));
  //   } else {
  //     props.openClientProfile();
  //   }
  // };
  if (props.task.personal) return null;
  return (
    <div
      css={`
        display: flex;
        align-items: center;
        button,
        a {
          margin-right: 5px;
        }
      `}
    >
      {/*
      {props.task.location_hr && (
        <Tooltip title={props.task.location_hr}>
          <InfoBadge greenish>
            <PinIcon width="13" />
          </InfoBadge>
        </Tooltip>
      )}
      {props.task.anon_client_msg &&
        !(!props.isTaskConsumer && props.task.hide_client) && (
          <Tooltip title={props.task.anon_client_msg}>
            <InfoBadge greenish>
              <EnvelopeIcon />
            </InfoBadge>
          </Tooltip>
        )}
      {props.task.created_by_anon_client && (
        <Tooltip title={props.t(`${ns}:custom_task_anon_client_tip`)}>
          <InfoBadge greenish>?</InfoBadge>
        </Tooltip>
      )}
      */}
      {props.task.prepayment?.amount && (
        <Tooltip
          title={CurrencyFormatter.format(props.task.prepayment.amount)!}
        >
          <InfoBadge greenish>
            <MoneyIcon width="20" />
          </InfoBadge>
        </Tooltip>
      )}
      {props.task.location_type === "master" && (
        <Tooltip title={props.t(`${ns}:search.loc_type.opts.master`)}>
          <InfoBadge greenish>
            <HomeIcon />
          </InfoBadge>
        </Tooltip>
      )}
      {props.task.location_type === "client" && (
        <Tooltip title={props.t(`${ns}:search.loc_type.opts.client`)}>
          <InfoBadge greenish>
            <CarIcon />
          </InfoBadge>
        </Tooltip>
      )}
      {props.task.location_type === "online" && (
        <Tooltip title={props.t(`${ns}:search.loc_type.opts.online`)}>
          <InfoBadge greenish>
            <GlobeIcon width="18" />
          </InfoBadge>
        </Tooltip>
      )}
      {props.task.saloon && (
        <CircleButton
          greenish
          title={props.t("common:salon")}
          as={Link}
          to={LinkGenerator.saloonProfile(props.task.saloon)}
        >
          <SaloonIcon />
        </CircleButton>
      )}
      {/*props.viewMode !== "client" &&
        props.task.client &&
        !(!props.isTaskConsumer && props.task.hide_client) && (
          <CircleButton
            title={props.t("common:profile")}
            light
            onClick={onTaskParticipantClick}
          >
            <AvatarIcon
              color={
                !props.isTaskConsumer && props.task.is_new_client
                  ? "var(--color-cta)"
                  : "currentColor"
              }
              width="20"
            />
          </CircleButton>
        )*/}
    </div>
  );
};

export default TaskBadges;
